const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

declare const uuid_string_brand: unique symbol;

/**
 * UUID that's an opaque type over string.
 *
 * At runtime, this is just a `string`,
 * but if you use the {@link Uuid} functions to
 * work with these UUIDs then it's gaurunteed
 * to be normalized and checked.
 */
export interface UuidString {
  readonly [uuid_string_brand]: unique symbol;
  toString(): string;
}

function string_as_string_branded(value: string): UuidString {
  return value as unknown as UuidString;
}

/**
 * UUIDs
 *
 * Helper methods for working with {@link UuidString}s safely
 */
export class Uuid {
  private constructor() {}

  /**
   * Expects a valid UUID string, otherwise throws
   */
  static from_string(uuid: string): UuidString {
    if (typeof uuid !== 'string') {
      throw new NotUuidError('not a string');
    }
    if (!UUID_REGEX.test(uuid)) {
      throw new NotUuidError('string is not a uuid');
    }

    return string_as_string_branded(uuid.toLowerCase());
  }

  /**
   * Create a new v4 UUID
   */
  static new_v4(): UuidString {
    let new_uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
      const random = (Math.random() * 16) | 0;
      const value = char === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    });

    return string_as_string_branded(new_uuid);
  }
}

export class NotUuidError extends Error {
  constructor(message: string) {
    super(message);
  }
}
